import { ReportPeriod } from "../types";

export const getPeriodDays = (period: ReportPeriod): number => {
  switch (period) {
    case "week": return 7;
    case "10days": return 10;
    case "2weeks": return 14;
    case "month": return 30;
    case "quarter": return 90;
    case "half": return 180;
    default: return 30;
  }
};

export const getPeriodLabel = (period: ReportPeriod): string => {
  switch (period) {
    case "week": return "Week";
    case "10days": return "10 Days";
    case "2weeks": return "2 Weeks";
    case "month": return "Month";
    case "quarter": return "Quarter";
    case "half": return "Half Year";
    default: return "Month";
  }
};

export const generatePeriodDays = (period: ReportPeriod): string[] => {
  const totalDays = getPeriodDays(period);
  const today = new Date();
  const dateArray: string[] = [];
  
  for (let i = totalDays - 1; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(today.getDate() - i);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    dateArray.push(`${year}-${month}-${day}`);
  }
  
  return dateArray;
};